import { ExpandedOrder } from "ts/api/order";
import { uniqBy } from "lodash";
import orderRefs from "api/order/refs";
import filterNotEmptyArray from "tools/common/filterNotEmptyArray";
import { apiV2 } from "api/firebase";

type Params = {
  exhibitorId: string;
  standId: string;
  showId: string;
  orderId: string;
  withDeleted?: boolean;
};

export const expandOrder = async ({
  showId,
  orderId,
  standId,
  exhibitorId,
  withDeleted,
}: Params): Promise<ExpandedOrder | null> => {
  const order = (await orderRefs.getDocument({ showId, orderId }).get()).data();
  if (!order) {
    return null;
  }

  const supplierCompanyIds = uniqBy(order.products, "owner.id").map(
    (p) => p.owner.id
  );

  const supplierCompanies = await apiV2.supplierCompany.getAllByIds({
    supplierCompanyIds: supplierCompanyIds.join(","),
  });

  const validCompanies = supplierCompanies.filter(filterNotEmptyArray);

  const exhibitorConnection = await apiV2.exhibitor.userConnection.getOne({
    showId,
    exhibitorUserId: exhibitorId,
    oldFirebaseStandId: standId,
    ...(withDeleted && { withDeleted: true }),
  });

  if (!validCompanies.length || !exhibitorConnection) {
    throw new Error("Failed to retrieve order data");
  }
  return {
    ...order,
    supplierCompanies: validCompanies,
    exhibitorConnection,
  };
};
